import React from 'react';
import { CardBody, Col, Row, CardText, CardTitle } from 'reactstrap';
import { Loading } from '../common/LoadingComponent';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MapPin, ArrowDown, MessageCircle, User, Package, Plane, Car, Train, Bus, Calendar, DollarSign } from '../../icons';

const TRANSPORT_ICONS = { Avion: Plane, Voiture: Car, Train: Train, Bus: Bus };

function parseDest(raw) {
    if (!raw) return [];
    return raw.split('--');
}

const DestRoute = ({ destination }) => {
    const parts = parseDest(destination);
    const stops = parts.slice(1, parts.length - 1).filter(Boolean);
    const last  = parts.filter(Boolean).slice(-1)[0];

    return (
        <>
            {stops.map((city, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '4px 0', color: 'var(--gray)', fontSize: '0.9rem' }}>
                    <ArrowDown size={14} strokeWidth={2} color="var(--gray-light)" />
                    {city}
                </div>
            ))}
            {last && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '4px 0', fontWeight: 600, color: 'var(--dark)' }}>
                    <MapPin size={16} strokeWidth={2} color="var(--primary)" />
                    {last}
                </div>
            )}
        </>
    );
};

function RenderAnnouncement({ announcement, user }) {
    const departure    = parseDest(announcement.departure);
    const isTrip       = !!announcement.dateDestination;
    const TransIcon    = TRANSPORT_ICONS[announcement.meansOfTransport] || Package;
    const fmt          = (ts) => new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: '2-digit', month: 'long' }).format(ts);

    return (
        <div style={{ background: 'white', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow)', border: '1px solid var(--border)', padding: '28px', marginTop: 16 }}>

            {/* Type badge */}
            <div style={{ marginBottom: 20 }}>
                <span style={{ background: isTrip ? 'var(--primary-light)' : '#fff3e0', color: isTrip ? 'var(--primary-dark)' : '#e65100', fontSize: '0.78rem', fontWeight: 700, padding: '5px 14px', borderRadius: 50, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                    {isTrip ? 'Trajet' : 'Demande d\'envoi'}
                </span>
            </div>

            {/* Dates */}
            <div style={{ marginBottom: 20 }}>
                {isTrip ? (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                            <Calendar size={15} strokeWidth={2} color="var(--primary)" />
                            <span>Départ&nbsp;: <strong>{fmt(announcement.dateDeparture)}</strong></span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                            <Calendar size={15} strokeWidth={2} color="var(--gray)" />
                            <span>Arrivée&nbsp;: <strong>{fmt(announcement.dateDestination)}</strong></span>
                        </div>
                    </>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                        <Calendar size={15} strokeWidth={2} color="var(--primary)" />
                        <span>À livrer avant le&nbsp;: <strong>{fmt(announcement.dateDeparture)}</strong></span>
                    </div>
                )}
            </div>

            {/* Route */}
            <div style={{ background: 'var(--bg-light)', borderRadius: 12, padding: '16px 18px', marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, fontWeight: 600, color: 'var(--dark)' }}>
                    <MapPin size={16} strokeWidth={2} color="var(--primary)" />
                    {departure[0] || departure[1] || '—'}
                </div>
                <DestRoute destination={announcement.destination} />
            </div>

            {/* Infos */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                    <Package size={16} strokeWidth={2} color="var(--primary)" />
                    <span><strong>Colis accepté&nbsp;:</strong> {announcement.objectAccepted}</span>
                </div>
                {announcement.meansOfTransport && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                        <TransIcon size={16} strokeWidth={2} color="var(--primary)" />
                        <span><strong>Transport&nbsp;:</strong> {announcement.meansOfTransport}</span>
                    </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.93rem', color: 'var(--gray-dark)' }}>
                    <DollarSign size={16} strokeWidth={2} color="var(--primary)" />
                    <span><strong>Prix&nbsp;:</strong> {announcement.price} €</span>
                </div>
                {announcement.description && (
                    <div style={{ background: 'var(--bg-light)', borderRadius: 10, padding: '12px 14px', fontSize: '0.9rem', color: 'var(--gray)', lineHeight: 1.6 }}>
                        {announcement.description}
                    </div>
                )}
            </div>

            {/* User */}
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
                <Link to={{ pathname: `/userprofile/${user.id}`, state: { from: window.location.pathname } }}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'var(--dark)', padding: '12px 16px', background: 'var(--bg-light)', borderRadius: 12, transition: 'background 0.15s' }}>
                    <img src="/assets/images/profil.svg" alt="avatar" width="40" height="40" style={{ borderRadius: '50%' }} />
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>{user.firstName} {user.lastName}</div>
                        <div style={{ fontSize: '0.78rem', color: 'var(--gray)' }}>Voir le profil</div>
                    </div>
                    <User size={16} strokeWidth={2} color="var(--gray-light)" style={{ marginLeft: 'auto' }} />
                </Link>

                <Link to={{ pathname: `/messages/${announcement.id}${user.id}`, state: { from: window.location.pathname } }}
                    className="btn btn-primary"
                    style={{ borderRadius: 50, padding: '13px 24px', fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none', justifyContent: 'center' }}>
                    <MessageCircle size={18} strokeWidth={2} />
                    Contacter {user.firstName}
                </Link>
            </div>
        </div>
    );
}

const AnnouncementDetail = (props) => {
    if (props.isLoading) return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;
    if (props.errMess)   return <div className="container text-center" style={{ padding: '80px 0' }}><h4>{props.errMess}</h4></div>;

    if (props.announcementWithUser != null) {
        const { announcement, user } = props.announcementWithUser;
        return (
            <div className="list-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-7 col-lg-6">
                            <h1 className="list-page__title" style={{ marginBottom: 4 }}>
                                {announcement.dateDestination ? 'Trajet proposé' : 'Demande de livraison'}
                            </h1>
                            <RenderAnnouncement announcement={announcement} user={user} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <div></div>;
};

export default AnnouncementDetail;
